import React, { useLayoutEffect, useRef, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const OverflowTooltip = ({
	children,
	className,
	tooltipClassName,
	placement = 'top',
	delay = { show: 100, hide: 400 }
}) => {
	const targetRef = useRef(null);
	const [isOverflowing, setIsOverflowing] = useState(false);

	useLayoutEffect(() => {
		const measure = () => {
			if (targetRef.current) {
				const { scrollWidth, clientWidth } = targetRef.current;
				setIsOverflowing(scrollWidth > clientWidth);
			}
		};

		measure();
		window.addEventListener('resize', measure);
		return () => window.removeEventListener('resize', measure);
	}, [children]);

	const target = (
		<div className={className} ref={targetRef}>
			{children}
		</div>
	);

	if (!isOverflowing) {
		return target;
	}

	return (
		<OverlayTrigger
			placement={placement}
			delay={delay}
			overlay={<Tooltip className={tooltipClassName}>{children}</Tooltip>}
		>
			{target}
		</OverlayTrigger>
	);
};

export default OverflowTooltip;
